import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="bg-hero-gradient py-24 px-6 text-bakery-cream relative" data-id="element-106">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-107">
        <FadeIn data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-109">
            Obtén el Manual del Pan:{' '}
            <span className="text-bakery-amber italic" data-id="element-110">Cero Errores</span>
            <br data-id="element-111" />
            por Marines Rosales
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-112">
          <div className="bg-bakery-cream/5 border border-bakery-amber/30 rounded-3xl p-8 md:p-12 my-12 backdrop-blur-sm" data-id="element-113">
            <p className="text-bakery-tan text-lg uppercase tracking-wider font-bold mb-4" data-id="element-114">
              Precio Especial de Lanzamiento
            </p>
            <a href="https://theassetsvault.com/cart/53783138926902:1" className="flex flex-col items-center mb-8 cursor-pointer hover:opacity-90 transition-opacity" data-id="element-115">
              <span className="inline-block bg-bakery-amber text-bakery-brown text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-116">
                🔥 42% de descuento
              </span>
              <div className="flex justify-center items-center space-x-4" data-id="element-117">
                <span className="text-3xl text-bakery-tan/50 line-through font-serif" data-id="element-118">
                  $23.99
                </span>
                <span className="text-6xl md:text-7xl font-serif font-bold text-bakery-amber drop-shadow-lg" data-id="element-119">
                  $13.99{' '}
                  <span className="text-2xl text-bakery-amber/80" data-id="element-120">USD</span>
                </span>
              </div>
            </a>

            <p className="text-lg text-bakery-tan mb-8" data-id="element-121">
              <span className="font-bold text-bakery-amber text-xl" data-id="element-122">
                Hoy solo $13.99
              </span>
            </p>

            <CTAButton href="https://theassetsvault.com/cart/53783138926902:1" className="w-full md:w-auto text-xl py-5 px-12" data-id="element-123">
              👉 Quiero mi manual + bonus por $13.99
            </CTAButton>

            <div className="mt-8 flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 text-sm text-bakery-tan/70" data-id="element-124">
              <div className="flex items-center" data-id="element-125">
                <LockIcon className="w-4 h-4 mr-2" data-id="element-126" />
                Pago 100% Seguro
              </div>
              <div className="flex items-center" data-id="element-127">
                <ShieldCheckIcon className="w-4 h-4 mr-2" data-id="element-128" />
                Acceso Inmediato
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}